// src/pages/admin/Media.jsx
import React from 'react';
import AdminSidebar from '../../components/admin/AdminSidebar';
import MediaManager from '../../components/admin/MediaManager';

const Media = () => {
  return (
    <div className="flex min-h-screen bg-gray-100">
      <AdminSidebar />
      <div className="flex-1 p-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-800">Media Library</h1>
          <p className="text-gray-600">Upload and manage images, videos, and documents</p>
        </div>
        <MediaManager />
      </div>
    </div>
  );
};

export default Media;